<db-loader
  [isLoading]="!!(globalLoaderVisible$ | async)"
  [isFixed]="true"
  [loaderText]="(globalLoaderText$ | async) || ''"
></db-loader>
